export enum RequisitesCascadeMode {
  TradersFirst = 'traders_first',
  ProvidersFirst = 'providers_first',
  TradersOnly = 'traders_only',
  ProvidersOnly = 'providers_only',
  SequentialAssignees = 'sequential_assignees',
  SequentialProviders = 'sequential_providers',
  Parallel = 'parallel',
  ParallelPriority = 'parallel_priority',
}
